import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET periods
export const getPeriods = async (year) => {
  try {
    const response = await api.get(`${API_URL}/time-overview/calendar-overview`, {
      params: { year }
    });

    console.log('🔄 Full backend response:', response); // Logs everything: headers, data, status, etc.
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching periods:', error.response || error.message);
    throw error;
  }
};

export const getUpcamingBlocked = async () => {
  try {
    const response = await api.get(`${API_URL}/time-overview/upcoming-blocked`);

    console.log('🔄 Upcaming blocked periods:', response); // Logs everything: headers, data, status, etc.
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching periods:', error.response || error.message);
    throw error;
  }
};

// Add periods with types
export const addPeriods = async (formData) => {
  const response = await api.post(`${API_URL}/time-overview/add-periods`, formData);
  return response.data;
};

// PUT periods
export const updatePeriods = async (id, formData) => {
  const response = await api.put(`${API_URL}/time-overview/update-periods/${id}`, formData);
  return response.data;
};

// DELETE periods
export const deletePeriods = async (formData) => {
  const response = await api.delete(`${API_URL}/time-overview/delete-periods`, {
    headers: {
      'Content-Type': 'application/json' // Keep this for DELETE with body
    },
    data: formData // Send formData as the request body
  });
  return response.data;
};